import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

// Eltafouk: account-level page to visually manage the reply-button auto-reply
// tree shared across all WhatsApp / Messenger / Instagram inboxes. Admin-only
// since it changes the bot behaviour for every customer on every channel.
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/auto-reply-bot'),
      meta: { permissions: ['administrator'] },
      component: SettingsWrapper,
      props: {
        headerTitle: 'AUTO_REPLY_BOT_SETTINGS.TITLE',
        icon: 'i-lucide-bot-message-square',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'auto_reply_bot_settings_index',
          component: Index,
          meta: { permissions: ['administrator'] },
        },
      ],
    },
  ],
};
